import RoutesStack from './routes/RoutesStack'

function App() {

  return (
    <>
      <RoutesStack />
    </>
  )
}

export default App
